const apis = ()=>{
const baseUrl = 'http://165.232.45.156:5555/'
const local = 'http://localhost:8080/'
const list = {
userId:'661d4ab8b9ff235ca2d14de0',
getPersonalities:`${baseUrl}personalities/list`,
getTenetsList:`${baseUrl}tenet/list`,
addUserPersonality:`${baseUrl}user/personality/add`,
userPersonalityList:`${baseUrl}user/personality/list`,
userTotalPersonalities:`${baseUrl}user/total/personalities`,
deleteUserPersonality:`${baseUrl}user/personality/delete`,
getUserTenetsList:`${baseUrl}user/tenet/list`,
addUserTenet:`${baseUrl}user/add/tenet`,
getUserTotalTenets:`${baseUrl}user/total/tenets`,
deleteUserTenet:`${baseUrl}user/delete/tenet`



}
return list

}

export default apis